// §29.5 / §9.1 — Chess as an in-process app. The manifest only (D-247).
//
// It holds the §26.7 play capability (D-210's list grows by three at §30.1), which is what lets a
// game be suggested to a connection. A title never learns what a connection *is*: it gets one
// session at a time and the calls that session needs.
import type { InProcessApp, PlayShellAccess } from '@hangar/shared';
import { createLazyApp } from '@/gamekit/lazy';

export function createChessApp(play: PlayShellAccess): InProcessApp {
  return createLazyApp<{ play: PlayShellAccess }>({
    app: {
      id: 'chess',
      name: 'Chess',
      icon: { glyph: 'crown', hue: 215 },
      keywords: ['chess', 'board', 'strategy', 'game', 'arcade'],
      category: 'Arcade',
      group: 'Boards',
      requiresAuth: true,
      window: { width: 1000, height: 760, minWidth: 640, minHeight: 520, multiWindow: false },
      jumpList: [
        { id: 'new-game', label: 'New game' },
        { id: 'flip', label: 'Flip board' },
      ],
    },
    load: () => import('./Chess'),
    props: { play },
  });
}
